import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {DbDatepickerComponent} from './datepicker';
import {DbDatepickerMonthComponent} from './datepicker-month';
import {DbDatepickerNavigationComponent} from './datepicker-navigation';
import {DbInputDatepickerDirective} from './datepicker.directive';
import {DatepickerSelectComponent} from "./datepicker-select/datepicker-select.component";

export {DbDatepickerComponent, IDatepickerNavigateEvent, IDbDatepickerState} from './datepicker';
export {DbInputDatepickerDirective} from './datepicker.directive';
export {DbCalendar, NgbPeriod, DbCalendarGregorian} from './db-calendar';
export {DbDatepickerMonthComponent} from './datepicker-month';
export {DbDatepickerNavigationComponent} from './datepicker-navigation';
export {DbDatepickerConfig} from './datepicker-config';
export {DbInputDatepickerConfig} from './datepicker-input-config';
export {DbDatepickerI18n, DbDatepickerI18nDefault} from './datepicker-i18n';
export {DbDateStruct} from './date-struct';
export {DbDate} from './db-date';
export {NgbDateAdapter} from './adapters/ngb-date-adapter';
export {NgbDateNativeAdapter} from './adapters/ngb-date-native-adapter';
export {DbDateParserFormatter} from './ngb-date-parser-formatter';

@NgModule({
  declarations: [
    DbDatepickerComponent, DbDatepickerMonthComponent, DbDatepickerNavigationComponent, DbInputDatepickerDirective,
    DatepickerSelectComponent
  ],
  // entryComponents: [DbDatepickerComponent],
  exports: [DbDatepickerComponent, DbInputDatepickerDirective, DbDatepickerMonthComponent, DatepickerSelectComponent],
  imports: [CommonModule, FormsModule]
})
export class DbDatepickerModule {
}
